var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-and-time"},[_c('div',{staticClass:"date-wrapper"},[_c('h1',{staticClass:"date"},[_vm._v(_vm._s(_vm.content.date))]),_c('h1',{staticClass:"date divider"},[_vm._v(" | ")]),_c('h1',{staticClass:"date"},[_vm._v(_vm._s(_vm.content.start_time)+" - "+_vm._s(_vm.content.end_time)+" UTC")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }